import { render, staticRenderFns } from "./AddInvitationCode.vue?vue&type=template&id=bd1fe13e&"
import script from "./AddInvitationCode.vue?vue&type=script&lang=js&"
export * from "./AddInvitationCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports